module.exports = __webpack_public_path__ + "img/9791160800746.138b076f.jpg";